
<div :class="jel_getClassObject(content)">
  <Titre
    :content="{
      titre: content.libTitreMotDePasse,
      type: 'titre',
      classesCss: 'pt-1',
    }"
  />
  <MessageMel
    v-if="isErreurSessionExpire && contentMessage.sessionExpire"
    class="mb-0 mt-1"
    :content="contentMessage.sessionExpire"
  />

  <!-- TODO: ajouter la date de dernière modification (en attente de OB) -->
  <!-- <span>{{ content.libDerniereModification }}</span> -->
  <MessageMel
    v-if="isCourrielEnvoye"
    class="mt-1 mb-2"
    :content="contentMessage.courrielEnvoye"
  />
  <button v-else class="bouton lienPrimaire p-0" @click="envoyerCourriel()">
    {{ content.libBoutonChangerMotDePasse }}
  </button>
  <MessageMel v-if="isCourrielEnvoyeErreur" class="mt-1 mb-0" :content="contentMessage.erreur" />
</div>
